module.exports = __webpack_public_path__ + "img/logo-kalls.603ede96.svg";